import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { Collapse } from "antd";
import { FaFilePdf, FaTrash } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Dropdown, Menu } from "antd";
import { useNavigate } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import { Row, Modal } from "react-bootstrap";
import { MdAddToQueue } from "react-icons/md";
import { FaPen } from "react-icons/fa";
import ToastNotification from "../../components/Common/ToastNotification";
import useCustomTranslation from "../../hooks/useCustomTranslation";
import { fetchWorkoutPlanListThunk } from "../../redux/Slices/workoutPlanListSlice";
import { fetchWorkoutTemplateThunk } from "../../redux/Slices/workoutTemplateSlice";
import { fetchWorkoutTemplateByIdThunk } from "../../redux/Slices/workoutTemplateListSlice";
import { v4 as uuidv4 } from "uuid";
import getFileAsBase64 from "../../utils/ImageUtils";
import Loader from "../../components/Common/Loader";
import {
  fetchWorkoutPlanThunk,
  clearUpdateMessage,
  deleteWorkoutPlanThunk,
} from "../../redux/Slices/workoutPlanSlice";
import { CONSTANTS } from "../../utils/Constant/Constant";
import CommonWorkoutPlan from "./CommonWorkoutPlan";
import appInsights from "../../AppInsights";

function ClientWorkoutPlan({ selectedClientId, selectedCoachId, status, clientDetails }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { Panel } = Collapse;
  const { trans } = useCustomTranslation();

  const { workoutPlan, updateSuccessMessage, updateFailedMessage } =
    useSelector((state) => state?.getWorkoutPlan);
  const { workoutPlanList, isloading } = useSelector(
    (state) => state?.getWorkoutPlanList ?? []
  );
  const { workoutTemplate, workoutTemplateIsloading, failedtoFetch } =
    useSelector((state) => state?.getWorkoutTemplate ?? []);
  const { workoutTemplateByID } = useSelector(
    (state) => state?.getWorkoutTemplateById ?? []
  );

  const [activeKey, setActiveKey] = useState(null);

  const [addPlan, setAddPlan] = useState(false);
  const [templateDetails, setTemplateDetails] = useState(false);
  const [selectedWorkoutPlanId, setSelectedWorkoutPlanId] = useState("");

  const [toShowAddplanPop, setToShowAddplanPop] = useState(true);

  const [workoutTemplateList, setworkoutTemplateList] = useState(null);
  const [toggleSelected, setToggleSelected] = useState(false);
  const [toastConfig, setToastConfig] = useState(null);
  const [showModal, setShowModal] = useState(false);

    //  Track Page View
  useEffect(() => {
    appInsights.trackPageView({
      name: "ClientWorkoutPlan",
      properties: {
        coachId: selectedCoachId || "N/A",
        clientId: selectedClientId || "N/A",
      },
    });
  }, [selectedCoachId, selectedClientId]);

  useEffect(() => {
    if (updateSuccessMessage) {
      setToastConfig({
        type: CONSTANTS.TOAST_SUCCESS,
        message: updateSuccessMessage,
        heading: trans("Common.success"),
      });
        setTimeout(() => {
          dispatch(clearUpdateMessage());
          setToastConfig(null);
        }, 3000);
    } else if (updateFailedMessage) {
      // Trigger success toast
      setToastConfig({
        type: CONSTANTS.TOAST_ERROR,
        message: updateFailedMessage,
        heading: trans("Common.failed"),
      });
        setTimeout(() => {
          dispatch(clearUpdateMessage());
          setToastConfig(null);
        }, 3000);
    }
  }, [dispatch, updateSuccessMessage, updateFailedMessage, trans]);

  useEffect(() => {
    if (selectedClientId && selectedCoachId) {
      dispatch(
        fetchWorkoutPlanListThunk({
          coachId: selectedCoachId,
          clientId: selectedClientId,
        })
      );

      // Track Workout Plan List Load
      appInsights.trackEvent({
        name: "ClientWorkoutPlan_List_Loaded",
        properties: {
          coachId: selectedCoachId,
          clientId: selectedClientId,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, selectedClientId, selectedCoachId]);

  const handlePanelChange = (key) => {
    if (activeKey === key) {
      setActiveKey(null);
      setToggleSelected(false);
    } else {
      setActiveKey(key);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleDeleteWorkoutPlan = async () => {
    await dispatch(
      deleteWorkoutPlanThunk({
        clientId: selectedClientId,
        coachWorkoutPlanId: selectedWorkoutPlanId,
      })
    ).then(() => {
      dispatch(
        fetchWorkoutPlanListThunk({
          coachId: selectedCoachId,
          clientId: selectedClientId,
        })
      );
    });
     // Track Delete Event
    appInsights.trackEvent({
      name: "ClientWorkoutPlan_Deleted",
      properties: {
        coachId: selectedCoachId,
        clientId: selectedClientId,
        workoutPlanId: selectedWorkoutPlanId,
      },
    });
    setSelectedWorkoutPlanId("");
    setShowModal(false);
  };

  const handleEditClick = async (e, key, planId) => {
    e.stopPropagation();
    // Track Edit Click
    appInsights.trackEvent({
      name: "ClientWorkoutPlan_Edit_Clicked",
      properties: {
        coachId: selectedCoachId,
        clientId: selectedClientId,
        workoutPlanId: planId,
      },
    });
    
    await dispatch(
      fetchWorkoutPlanThunk({
        clientId: workoutPlanList.clientId,
        coachId: workoutPlanList.coachId,
        coachWorkoutPlanId: planId,
      })
    )
      .then(async (resultAction) => {
        if (fetchWorkoutPlanThunk.fulfilled.match(resultAction)) {
          let base64Image = "";
          if (resultAction?.payload?.workoutPlanImage?.blobUrl) {
            base64Image = await getFileAsBase64(
              resultAction.payload.workoutPlanImage.blobUrl
            );
          }

          const clientWorkoutPlanSessionRequests = await Promise.all(
            resultAction.payload?.clientWorkoutPlanSessionResponses?.map(
              async (session) => {
                let sessionPhotoBase64 = "";
                if (session?.sessionPhotoImage?.blobUrl) {
                  sessionPhotoBase64 = await getFileAsBase64(
                    session.sessionPhotoImage.blobUrl
                  );
                }

                return {
                  clientWorkoutPlanId:
                    resultAction.payload?.clientWorkoutPlanId,
                  clientWorkoutPlanSessionId:
                    session?.clientWorkoutPlanSessionId,
                  clientId: selectedClientId,
                  exerciseCount: session?.exerciseCount,
                  totalSets: session?.totalSets,
                  sessionName: session?.sessionName,
                  indexOrder: session?.indexOrder,
                  sessionType: "",
                  equipment: session?.equipments,
                  sessionPhotoBase64,
                  sessionPhotoFileName:
                    session?.sessionPhotoImage?.fileName || "",
                  sessionPhotoMediaType:
                    session?.sessionPhotoImage?.mediaType || "",
                  sessionPhotoFileType:
                    session?.sessionPhotoImage?.fileType || "",
                  sessionPhotoSourceType:
                    session?.sessionPhotoImage?.sourceType || "",
                  existingWorkoutPlanSessionImageId: null,
                  clientWorkoutPlanExerciseRequests:
                    session?.clientWorkoutPlanExerciseResponses?.map(
                      (exercise) => ({
                        clientWorkoutPlanSessionId:
                          exercise?.clientWorkoutPlanSessionId,
                        clientWorkoutPlanExerciseId:
                          exercise?.clientWorkoutPlanExerciseId,
                        exerciseName: exercise?.exercise,
                        exerciseId: exercise?.exerciseId || "",
                        blobUrl: exercise?.exerciseImage?.blobUrl || "",
                        sets: exercise?.sets,
                        reps: exercise?.reps,
                        sec: exercise?.sec,
                        setType: "",
                        dropSet: "",
                        indexOrder: exercise?.indexOrder,
                        notes: exercise?.note || CONSTANTS.NOTES,
                      })
                    ),
                };
              }
            )
          );

          const planSend = {
            clientWorkoutPlanId: resultAction.payload?.clientWorkoutPlanId,
            coachId: resultAction.payload?.coachId,
            clientId: selectedClientId,
            name: resultAction.payload?.name || CONSTANTS.DEFAULT_NAME,
            session: resultAction.payload?.sessionCount?.toString(),
            description: resultAction.payload?.description,
            introText: resultAction.payload?.introText,
            language: resultAction.payload?.language,
            plannedVolumeReps: resultAction.payload?.plannedVolumeReps,
            plannedVolumeSets: resultAction.payload?.plannedVolumeSets,
            plannedVolumeSec: resultAction.payload?.plannedVolumeSec,
            workoutPlanImageBase64: base64Image || "",
            workoutPlanImageFileName:
              resultAction.payload?.workoutPlanImage?.fileName,
            workoutPlanImageMediaType:
              resultAction.payload?.workoutPlanImage?.mediaType,
            workoutPlanImageFileType:
              resultAction.payload?.workoutPlanImage?.fileType,
            workoutPlanImageSourceType:
              resultAction.payload?.workoutPlanImage?.sourceType,
            coverPhotoBase64: "",
            coverPhotoFileName: "",
            coverPhotoMediaType: "",
            coverPhotoFileType: "",
            coverPhotoSourceType: "",
            existingWorkoutPlanImageId: null,
            existingCoverPhotoImageId: null,
            createdOrUpdatedBy: "",
            clientWorkoutPlanSessionRequests,
          };

          const mappedTemplate = {
            workoutTemplateID: planSend?.clientWorkoutPlanId,
            coachId: planSend?.coachId,
            name: planSend?.name,
            description: planSend?.description,
            numberOfSessions:
              planSend?.clientWorkoutPlanSessionRequests?.length,
            sessions: planSend?.clientWorkoutPlanSessionRequests?.map(
              (session) => ({
                workoutSessionID: session?.clientWorkoutPlanSessionId,
                workoutTemplateID: planSend?.clientWorkoutPlanId,
                indexOrder: session?.indexOrder || 0,
                exerciseCount: session?.exerciseCount,
                sessionName: session?.sessionName,
                sessionType: session?.sessionType,
                exercises: session?.clientWorkoutPlanExerciseRequests?.map(
                  (exercise) => ({
                    workoutTemplateExercisesId:
                      exercise?.clientWorkoutPlanExerciseId,
                    workoutSessionID: session?.clientWorkoutPlanSessionId,
                    exerciseID: exercise?.exerciseId,
                    sets: exercise?.sets,
                    reps: exercise?.reps,
                    sec: exercise?.sec,
                    setType: exercise?.setType,
                    exerciseNote: exercise?.note,
                    exerciseName: exercise?.exerciseName,
                    exerciseImage: exercise?.exerciseImage,
                    exerciseVideo: exercise?.exerciseVideo,
                    indexOrder: exercise?.indexOrder
                  })
                ),
              })
            ),
          };

          const prefilledSessions = mappedTemplate?.sessions?.map(
            (session) => ({
              id: session?.workoutSessionID,
              name: session?.sessionName,
              exercises: session?.exercises?.map((exercise) => ({
                exerciseId: exercise?.exerciseID,
                name: exercise?.exerciseName,
                sets: exercise?.sets || CONSTANTS.ONE,
                reps: exercise?.reps || CONSTANTS.ONE,
                sec: exercise?.sec || "",
                setType: exercise?.setType || "",
                blobUrl: exercise?.exerciseImage?.blobUrl || null,
                exerciseNote: exercise?.exerciseNote || CONSTANTS.NOTES,
                indexOrder: exercise?.indexOrder,
              })),
            })
          );

          navigate("/toolbox/builder", {
            state: {
              selectedCoachId,
              selectedClientId,
              sessions: prefilledSessions,
              isSelectedFromClient: true,
              initialTemplate: null,
              editActualWorkoutPlan: planSend,
              isEdit: true,
              clientDetails: clientDetails
            },
          });
        } else {
          console.error(
            trans("ClientWorkout.failedToFetchWorkoutPlan"),
            resultAction.payload
          );
        }
      })
      .catch((error) => {
        console.error(CONSTANTS.FAILED_TO_FETCH, error);
      });
  };

  const handleArrowClick = (e, key, planId, clientId) => {
    dispatch(
      fetchWorkoutPlanThunk({
        clientId: workoutPlanList.clientId,
        coachId: workoutPlanList.coachId,
        coachWorkoutPlanId: planId,
      })
    );
    setToggleSelected(!toggleSelected);
    e.stopPropagation();
    handlePanelChange(key);
  };

  useEffect(() => {
    if (workoutTemplate != null) {
      setworkoutTemplateList(workoutTemplate);
    }
  }, [workoutTemplate, dispatch]);

  const handleCreateFromScratch = () => {
     // Track Create From Scratch
    appInsights.trackEvent({
      name: "ClientWorkoutPlan_Create_From_Scratch",
      properties: {
        coachId: selectedCoachId,
        clientId: selectedClientId,
      },
    });

    const workoutId = uuidv4();
    const templateData = {
      workoutTemplateID: workoutId,
      coachId: selectedCoachId,
      name: "",
      description: CONSTANTS.SIX_SESSION_EMPTY,
      numberOfSessions: CONSTANTS.SIX,
      sessions: Array.from({ length: CONSTANTS.SIX }, (v, i) => ({
        workoutSessionID: uuidv4(),
        workoutTemplateID: workoutId,
        exerciseCount: CONSTANTS.ZERO,
        sessionName: `${trans("ClientWorkout.one")} ${i + CONSTANTS.ONE}`,
        sessionType: "",
        exercises: [],
      })),
    };

    if (templateData) {
      const prefilledSessions = templateData.sessions.map((session) => ({
        id: session.workoutSessionID,
        name: session.sessionName,
        exercises: session.exercises.map((exercise) => ({
          exerciseId: exercise.exerciseID,
          name: exercise.exerciseName,
          sets: exercise.sets || trans("ClientWorkout.one"),
          reps: exercise.reps || trans("ClientWorkout.one"),
          sec: exercise.sec || "",
          setType: exercise.setType || "",
          blobUrl: exercise.exerciseImage?.blobUrl || null,
          exerciseNote: exercise.exerciseNote || "",
          indexOrder: exercise.indexOrder,
        })),
      }));

      const actualForm = {
        clientWorkoutPlanId: workoutId,
        coachId: selectedCoachId,
        clientId: selectedClientId,
        name: "",
        session: trans("ClientWorkout.six"),
        description: "",
        introText: "",
        language: "en",
        plannedVolumeReps: "",
        plannedVolumeSets: "",
        plannedVolumeSec: trans("ClientWorkout.zero"),
        workoutPlanImageBase64: "",
        workoutPlanImageFileName: "",
        workoutPlanImageMediaType: "",
        workoutPlanImageFileType: "",
        workoutPlanImageSourceType: "",
        coverPhotoBase64: "",
        coverPhotoFileName: "",
        coverPhotoMediaType: "",
        coverPhotoFileType: "",
        coverPhotoSourceType: "",
        existingWorkoutPlanImageId: null,
        existingCoverPhotoImageId: null,
        createdOrUpdatedBy: selectedCoachId,
        clientWorkoutPlanSessionRequests: [
          {
            clientWorkoutPlanId: workoutId,
            clientWorkoutPlanSessionId: uuidv4(),
            exerciseCount: CONSTANTS.ZERO,
            totalSets: CONSTANTS.ZERO,
            sessionName: CONSTANTS.SESSION_ONE,
            sessionType: "",
            indexOrder: 0,
            equipment: CONSTANTS.BARBELL,
            sessionPhotoBase64: "",
            sessionPhotoFileName: "",
            sessionPhotoMediaType: "",
            sessionPhotoFileType: "",
            sessionPhotoSourceType: "",
            existingWorkoutPlanSessionImageId: null,
            clientWorkoutPlanExerciseRequests: [],
          },
          {
            clientWorkoutPlanId: workoutId,
            clientWorkoutPlanSessionId: uuidv4(),
            exerciseCount: CONSTANTS.ZERO,
            totalSets: CONSTANTS.ZERO,
            sessionName: CONSTANTS.SESSION_TWO,
            sessionType: "",
            indexOrder: 1,
            equipment: CONSTANTS.BARBELL,
            sessionPhotoBase64: "",
            sessionPhotoFileName: "",
            sessionPhotoMediaType: "",
            sessionPhotoFileType: "",
            sessionPhotoSourceType: "",
            existingWorkoutPlanSessionImageId: null,
            clientWorkoutPlanExerciseRequests: [],
          },
          {
            clientWorkoutPlanId: workoutId,
            clientWorkoutPlanSessionId: uuidv4(),
            exerciseCount: CONSTANTS.ZERO,
            totalSets: CONSTANTS.ZERO,
            sessionName: CONSTANTS.SESSION_THREE,
            sessionType: "",
            indexOrder: 2,
            equipment: CONSTANTS.BARBELL,
            sessionPhotoBase64: "",
            sessionPhotoFileName: "",
            sessionPhotoMediaType: "",
            sessionPhotoFileType: "",
            sessionPhotoSourceType: "",
            existingWorkoutPlanSessionImageId: null,
            clientWorkoutPlanExerciseRequests: [],
          },
          {
            clientWorkoutPlanId: workoutId,
            clientWorkoutPlanSessionId: uuidv4(),
            exerciseCount: CONSTANTS.ZERO,
            totalSets: CONSTANTS.ZERO,
            sessionName: CONSTANTS.SESSION_FOUR,
            sessionType: "",
            indexOrder: 3,
            equipment: CONSTANTS.BARBELL,
            sessionPhotoBase64: "",
            sessionPhotoFileName: "",
            sessionPhotoMediaType: "",
            sessionPhotoFileType: "",
            sessionPhotoSourceType: "",
            existingWorkoutPlanSessionImageId: null,
            clientWorkoutPlanExerciseRequests: [],
          },
          {
            clientWorkoutPlanId: workoutId,
            clientWorkoutPlanSessionId: uuidv4(),
            exerciseCount: CONSTANTS.ZERO,
            totalSets: CONSTANTS.ZERO,
            sessionName: CONSTANTS.SESSION_FIVE,
            sessionType: "",
            indexOrder: 4,
            equipment: CONSTANTS.BARBELL,
            sessionPhotoBase64: "",
            sessionPhotoFileName: "",
            sessionPhotoMediaType: "",
            sessionPhotoFileType: "",
            sessionPhotoSourceType: "",
            existingWorkoutPlanSessionImageId: null,
            clientWorkoutPlanExerciseRequests: [],
          },
          {
            clientWorkoutPlanId: workoutId,
            clientWorkoutPlanSessionId: uuidv4(),
            exerciseCount: CONSTANTS.ZERO,
            totalSets: CONSTANTS.ZERO,
            sessionName: CONSTANTS.SESSION_SIX,
            sessionType: "",
            indexOrder: 5,
            equipment: CONSTANTS.BARBELL,
            sessionPhotoBase64: "",
            sessionPhotoFileName: "",
            sessionPhotoMediaType: "",
            sessionPhotoFileType: "",
            sessionPhotoSourceType: "",
            existingWorkoutPlanSessionImageId: null,
            clientWorkoutPlanExerciseRequests: [],
          },
        ],
      };

      navigate("/toolbox/builder", {
        state: {
          selectedCoachId: selectedCoachId,
          selectedClientId: selectedClientId,
          sessions: prefilledSessions,
          initialTemplate: null,
          isSelectedFromClient: true,
          editActualWorkoutPlan: actualForm,
          isEdit: false,
          clientDetails: clientDetails
        },
      });
    }
  };

  useEffect(() => {
    if (templateDetails && workoutTemplateByID) {
      const processTemplateData = async () => {
        try {
          // Process session photos if they exist
          const sessionsWithPhotos = await Promise.all(
            workoutTemplateByID.sessions.map(async (session) => {
              let sessionPhotoBase64 = "";

              if (session?.sessionPhotoImage?.blobUrl) {
                sessionPhotoBase64 = await getFileAsBase64(
                  session.sessionPhotoImage.blobUrl
                );
              }

              return {
                id: session.workoutSessionID,
                name: session.sessionName,
                sessionPhotoBase64,
                sessionPhotoFileName:
                  session?.sessionPhotoImage?.fileName || "",
                sessionPhotoMediaType:
                  session?.sessionPhotoImage?.mediaType || "",
                sessionPhotoFileType:
                  session?.sessionPhotoImage?.fileType || "",
                sessionPhotoSourceType:
                  session?.sessionPhotoImage?.sourceType || "",
                sessionBlobUrl: session?.sessionPhotoImage?.blobUrl,
                sessionFileType: session?.sessionPhotoImage?.fileType,
                exercises: session.exercises.map((exercise) => ({
                  exerciseId: exercise.exerciseID,
                  name: exercise.exerciseName,
                  sets: exercise.sets || CONSTANTS.ONE,
                  reps: exercise.reps || CONSTANTS.ONE,
                  sec: exercise.sec || "",
                  setType: exercise.setType || "",
                  blobUrl: exercise.exerciseImage?.blobUrl || null,
                  exerciseNote: exercise.exerciseNote || CONSTANTS.NOTES,
                  indexOrder: exercise.indexOrder
                })),
              };
            })
          );

          setTemplateDetails(false);

          navigate("/toolbox/builder", {
            state: {
              selectedCoachId: selectedCoachId,
              selectedClientId: selectedClientId,
              sessions: sessionsWithPhotos,
              isSelectedFromClient: true,
              initialTemplate: workoutTemplateByID,
              editActualWorkoutPlan: null,
              isEdit: false,
              clientDetails: clientDetails
            },
          });
        } catch (error) {
          console.error(CONSTANTS.FAILED_TO_PROCESS_TEMPLATE, error);
        }
      };

      processTemplateData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    workoutTemplateByID,
    templateDetails,
    selectedCoachId,
    selectedClientId,
    navigate,
  ]);

  const handleTemplateClick = async (TemplateId) => {
    setTemplateDetails(true);
    await dispatch(
      fetchWorkoutTemplateByIdThunk({
        Id: TemplateId,
      })
    );
  };

  const menu1 = (
    <Menu mode="vertical" className="workout-menu">
      {workoutTemplateIsloading ? (
        <Loader />
      ) : workoutTemplateList?.workoutTemplates?.length > 0 ? (
        workoutTemplateList.workoutTemplates.map((template) => (
          <Menu.Item key={template.id} className="menu-item">
            <button
              type="button"
              className="link-button"
              onClick={() => handleTemplateClick(template.id)}
            >
              {template.description}
            </button>
          </Menu.Item>
        ))
      ) : failedtoFetch ? (
        <ToastNotification
          type={CONSTANTS.TOAST_ERROR}
          message="Please create workout template from toolbox"
          heading={trans("Common.failed")}
        />
      ) : null}
    </Menu>
  );

  return (
    <div className=" backgroundWhite ">
      {isloading === true ? (
        <div>
          <Loader />
        </div>
      ) : (
        <div>
          <div className="d-flex flex-add-plan">
            <h6 className="mt-3 ">{trans("ClientWorkout.workoutPlan")}</h6>

            <div>
              <button
                onClick={() => {
                  setAddPlan(!addPlan);

                  setActiveKey(null);

                  setToShowAddplanPop(true);
                }}
                disabled={status}
                className={`mt-3 add-plan-button bg-${
                  status ? "primary" : "gray"
                }`}
              >
                <i className="bi bi-plus"> </i>
                {trans("ClientWorkout.addPlan")}
              </button>
            </div>
          </div>

          <div>
            {workoutPlanList?.workoutPlans ? (
              <div>
                <Collapse collapsible={false} activeKey={activeKey} accordion>
                  {workoutPlanList?.workoutPlans?.map((item) => (
                    <Panel
                      className="Panel-workout-accordion"
                      key={item?.workoutPlanId}
                      header={
                        <div className="collapse-header-workoutplan">
                          <span className="workout-plan-plan">
                            {item?.name}
                          </span>

                          <div className="session-count">
                            <span></span>
                          </div>

                          <div className="workout-pdf-panel">
                            <FaFilePdf className="pdf-icon" />
                          </div>

                          <div className="fa-pen-edit">
                            <FaPen
                              onClick={(e) => {
                                handleEditClick(
                                  e,
                                  item.workoutPlanId,
                                  item.workoutPlanId,
                                  item.clientId
                                );
                              }}
                              className="ellipsis-icon"
                            />
                          </div>
                          <div className="fa-pen-edit delete-icon-workoutplan">
                            <FaTrash
                              onClick={() => {
                                setShowModal(true);
                                setSelectedWorkoutPlanId(item?.workoutPlanId);
                              }}
                              className="ellipsis-icon"
                            />
                          </div>
                          <DownOutlined
                            className="down-arrow-accordion"
                            onClick={(e) => {
                              handleArrowClick(
                                e,
                                item.workoutPlanId,
                                item.workoutPlanId,
                                item.clientId
                              );
                            }}
                          />
                        </div>
                      }
                      showArrow={false}
                    >
                      <CommonWorkoutPlan workoutPlan={workoutPlan} />
                    </Panel>
                  ))}
                </Collapse>
              </div>
            ) : (
              <div className="middle-text-noplan">
                {trans("ClientWorkout.noWorkoutPlan")}
              </div>
            )}

            {addPlan === true && (
              <div className=" Add-newWorkout-pop">
                <div>
                  {toShowAddplanPop && (
                    <div>
                      <Row>
                        <div className="flex-add-plan">
                          <div className="workout-plan-plan-add">
                            {trans("ClientWorkout.newWorkoutPlan")}
                          </div>
                          <div
                            onClick={() => {
                              setAddPlan(false);
                            }}
                            className="cross"
                          >
                            <FaTimes />
                          </div>
                        </div>
                      </Row>
                      <Row>
                        <div className="mt-4">
                          <div className="d-flex align-center">
                            <div className="create-button-icon">
                              <MdAddToQueue />
                            </div>
                            <div className="plan-or"></div>
                            <div className="template-button-icon">
                              <MdAddToQueue />
                            </div>
                          </div>
                        </div>
                      </Row>
                      <Row>
                        <div className="move-data-right">
                          <div className="d-flex">
                            <div className="scratch-button">
                              <div className="p-1">
                                {trans("ClientWorkout.createFromScratch")}
                              </div>
                              <div>
                                <div>
                                  <button
                                    className="blue-button-scratch"
                                    onClick={() => {
                                      handleCreateFromScratch();
                                    }}
                                  >
                                    {trans("ClientWorkout.addSixSession")}
                                    <span class=" bi bi-chevron-down"></span>
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div className="plan-or">
                              {trans("ClientWorkout.or")}
                            </div>
                            <div className="template-button">
                              <div className="p-1">
                                {trans("ClientWorkout.createFromTemplate")}
                              </div>
                              <div>
                                <Dropdown
                                  overlay={menu1}
                                  onClick={() => {
                                    dispatch(
                                      fetchWorkoutTemplateThunk({
                                        coachId: selectedCoachId,
                                      })
                                    );
                                  }}
                                  trigger={["click"]}
                                >
                                  <button className="blue-button-template">
                                    {trans("ClientWorkout.fromTemplate")}
                                    <span class=" bi bi-chevron-down"></span>
                                  </button>
                                </Dropdown>
                                <div></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Row>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          <Modal
            show={showModal}
            onHide={handleModalClose}
            centered
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                {trans("Common.confirmation")}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Do you want to delete this workout plan?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="outline-primary"
                onClick={handleModalClose}
                className="cancel-button w-25 p-1"
              >
                {trans("Common.cancel")}
              </Button>
              <Button
                className="saveButton w-25 ml-2"
                onClick={handleDeleteWorkoutPlan}
              >
                {trans("Common.delete")}
              </Button>
            </Modal.Footer>
          </Modal>
          {toastConfig && (
            <ToastNotification
              type={toastConfig.type}
              message={toastConfig.message}
              heading={toastConfig.heading}
            />
          )}
        </div>
      )}
    </div>
  );
}
export default ClientWorkoutPlan;
